<template>
    <div class="">
        <div class="nothing-found" v-if="!isLoad && items.length === 0 && !isErrorPage && !isSearch" >
            <svg class="big-icon" >
                <use xlink:href="@/assets/img/big-icons-sprite.svg#pen"></use>
            </svg>
            <div class="text-size-l text-color-grey mt16">
            Здесь пока ничего нет...
            </div>
			<div v-if="!isScreencasts" class="rules__btn mt16" @click="openAddRuleParent">
                <span class="elem">
                    <span class="i i-plus6"></span>
                    Добавить правило
                </span>
            </div>
        </div>

        <draggable :forceFallback="true" :disabled="!canDrag || popups.addRule.show || isRemovedPage"
                    element="div"
                   v-model="items"
                   @start="dragStart"
                   @end="dragSave"
                   :move="dragStatus"
                   :animation="150"
                   :touchStartThreshold="3"
                   :delay="10"
                   class="rules"
                   :class="{'dragging': drag}"
                   v-else-if="!isErrorPage"
                   >
            <div class="rule" v-for="(item, index) in items" :id="'rule'+item.id" :key="'item_'+item.id" :class="{rulepreloader: item.texLoading,
				highlighted:  item.opened && item.id == highlightedId,
				updated: (item.updated || isRemovedPage) && !(item.finally && user.access_rights.is_owner),
				ready: item.finally && (user.access_rights.is_owner || (curTopSection && user.is_chef))}">
                <div class="rule__sections" v-if="isRemovedPage && item.sections_before.length" v-html="removedSectionsBreadcrumbs(item) ">

                </div>
                <div class="rule__sections" v-else-if="(isSearch || isScreencasts )&& item.sectionTopName && item.sectionName">
                    <span v-html="item.sectionTopName" v-if="item.sectionTop != item.section"></span>
                    <span class="text-color-grey ml4 mr4" v-if="item.sectionTop != item.section">/</span>
                    <a href="javascript:void(0)" @click.prevent="goToRule('/sid'+activeTopSection+'/sub'+item.section+'/')" v-if="(isSearch || isScreencasts) && item.sectionTop == item.section" v-html="item.sectionName"></a>
                    <a href="javascript:void(0)" @click.prevent="goToRule('/sid'+item.sectionTop+'/sub'+item.section+'/')" v-else-if="(isSearch || isScreencasts)" v-html="item.sectionName"></a>
                    <span v-else v-html="item.sectionName"></span>
                </div>
                <div class="rule__info">
                    <span class="text-color-grey text-size-xs count">№{{item.id}}</span>
                </div>
                <a :href="'/rules/sid'+item.sectionTop+'/sub'+item.section+'/'+'rule'+item.id + '/'" class="rule-top" @click.prevent="toggleRule(index, item, $event)" :id="'rule_'+item.id"></a>
                <div class="rule__preloader-wrapper">
                    <div class="rule__preloader"></div>
                </div>
                <svg v-if="item.isCheckEdit" class="btn-preloader">
                    <use xlink:href="@/assets/img/big-icons-sprite.svg#preloader"></use>
                </svg>

                <span class="recover" @click="openRecover(item)" v-if="isRemovedPage">
                    <span class="i i-refresh4"></span>
                </span>

                <span class="delete" @click="openRemoveRule(item)" v-if="isRemovedPage">
                    <span class="i i-trash2"></span>
                    <span class="i i-trash2-active"></span>
                </span>
                <div class="rule__text-container">
                    <div class="rule__text"  tabindex="0" @click="handleOffset($event, item)" :class="{'is-search': isSearch || isScreencasts}">
                        <span v-html="item.name"></span>
                        <span  @click="goToRule('/sid'+item.sectionTop+'/sub'+activeTopSection+'/rule'+item.id+'/')" class="i i-link3" v-if="(isSearch || isScreencasts) && item.sectionTop == item.section"></span>
                        <span  @click="goToRule('/sid'+item.sectionTop+'/sub'+item.section+'/rule'+item.id+'/')" class="i i-link3" v-else-if="isSearch || isScreencasts"></span>
                    </div>
					<div v-if="item.ruleType && !filterType['value'] && (user.access_rights.is_tech_writer || user.access_rights.is_owner)" class="rule-type" :class="ruleColor(item.ruleType)">
                        {{ ruleTypeName(item.ruleType) }}
					</div>
                </div>
            </div>
        </draggable>
        <div class="preloader-page" v-if="isLoad">
            <div class="preloader"></div>
        </div>

        <div class="jin">
          <img src="@/assets/img/lamp.png" alt="" class="lamp" @click="jinShow = !jinShow" :class="{'showed': jinShow}">
          <img src="@/assets/img/jinn.png" alt="" class="jinn" :class="{'showed': jinShow}">
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex';
import Gallery from '@/components/Gallery.vue';
import draggable from '@/helpers/vuedraggable.js';
import {copyTextToClipboard} from "@/helpers/util/helper";
import DynamicHtml from '@/components/moderator/Rules/DynamicHtml.vue';
import Popup from '@/components/modal/Popup.vue';
import RecoverRule from '@/components/modal/rules/RecoverRule.vue';
import Tooltip from '@/components/Tooltip.vue';


export default {
        name: "List",
        components: {
            Gallery,
            draggable,
            DynamicHtml,
            Popup,
            RecoverRule,
            Tooltip,
        },
        created() {
            // Временно оставил 29.04.2021
            if(this.$route.hash !== ""){
                this.$store.dispatch('popups/open', {name: this.popups.ruleDetail.name});
                this.fetchData().then(()=>{
                    this.$nextTick(()=>{
                        let isFind = false;
                        for (let itemIndex in this.items) {
                            if(this.$route.hash.replace('#rule','') == this.items[itemIndex].id){
                                this.toggleRule(itemIndex, this.items[itemIndex]);
                                this.highlightedId = this.items[itemIndex].id
                                isFind = true;
                            }
                        }
                        if(!isFind && +this.$route.hash.replace('#rule','') > 0){
                            this.$store.dispatch('rules/getRemoveItem', {id: this.$route.hash.replace('#rule','')}).then(()=>{
                                for (let itemIndex in this.items) {
                                    if(this.$route.hash.replace('#rule','') == this.items[itemIndex].id){
                                        this.toggleRule(itemIndex, this.items[itemIndex]);
                                        this.highlightedId = this.items[itemIndex].id;
                                    }
                                }
                            });
                        }
                    });

                });
            }
            else if(this.$route.name == "moderator-rules-detail" && this.$route.params.ruleid){
                this.$store.dispatch('popups/open', {name: this.popups.ruleDetail.name});
                this.fetchData().then(()=>{
                    this.$nextTick(()=>{
                        for (let itemIndex in this.items) {
                            if(this.$route.params.ruleid == this.items[itemIndex].id){
                                this.toggleRule(itemIndex, this.items[itemIndex]);
                                this.highlightedId = this.items[itemIndex].id
                            }
                        }
                    })
                });
            }
            else{
                if(this.$route.name !== 'screencasts') {
                    this.fetchData();
                }
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
            this.$store.subscribe((mutation, state) => {
                if(mutation.type=='rules/toggleRolled'){
                    for (let itemIndex in this.items) {
                        if((this.rolled && !this.items[itemIndex].opened) || (!this.rolled && this.items[itemIndex].opened)){
                            this.toggleRule(itemIndex, this.items[itemIndex]);
                        }
                    }
                }
            });
        },
        props: {
            isErrorPage: {
                default: false
            },
            filterType: {
                default: 0
            }
        },
        data(){
            return {
                drag: false,
                canToggle: true,
                highlightedId: false,
                textElem: '',
                offsetX: 0,
                stringNum: '',
                scrollTop: 0,
                recoverItem: {},
                currentItem: '',
                jinShow: false,
                typesOptions: {
                    0:{ name: 'все'},
                    1: {name: 'заготовка'},
                    2: {name: 'черновик'},
                    4: {name: 'правило'},
                    5: {name: 'архивное'},
                },
            }
        },
        computed: {
            ...mapState({
                filterRuleType: state => state.rules.selectedFilterRuleType,
                isLoad: state => state.rules.isLoadItems,
                isLoadEditRule: state => state.rules.isLoadEditRule,
                sections: state => state.rules.sections,
                popups: state => state.popups.items,
                isSearch: state => state.rules.isSearch,
                rolled: state => state.rules.rolled,
                cursorPositionObj: state => state.rules.cursorPositionObj,
                topSections: state => state.rules.topSections,
                searchStr: state => state.rules.searchStr,
                canDragState: state => state.rules.canDrag,
                user: state => state.users.user,
                sectionsLock: state => state.rules.sectionsLock,
            }),
            isScreencasts() {
                return this.$route.name === 'screencasts';
            },
            canDrag(){
                if(this.user.access_rights.is_owner || (this.curTopSection && (this.curTopSection.rights == 'W' || this.user.is_chef))) {
                    return this.canDragState
                } else {
                    return false
                }
            },
            activeTopSection(){
                //if(this.isSearch) return false;
                if(this.topSections[0]){
                    return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
                }
                else
                    return false;
            },
            activeSection(){
                let subSectionID;
                
                if(this.$route.params.subid){
                    subSectionID = this.$route.params.subid
                }
                /*else if(this.sectionsLock[0]){
                    subSectionID = this.sectionsLock[0].id;
                }*/
                else if(this.sections && this.sections[0]){

                    if(this.sections[0].sections){
                        subSectionID = this.sections[0].sections[0].id;
                    }else{
                        subSectionID = this.sections[0].id;
                    }
                    
                }
                return subSectionID;
            },
            items: {
                get(){
                    if(this.isSearch) {
                        const findInTitle = [];
                        const findInText = [];
                        const items = this.$store.getters['rules/getItems'];
                        for (const r in items) {
                            if (items[r].name.search(new RegExp(this.searchStr, 'gi')) !== -1) {
                                findInTitle.push(items[r]);
                            } else {
                                findInText.push(items[r]);
                            }
                        }
                        return [...findInTitle, ...findInText];
                    }
                    return this.$store.getters['rules/getItems']
                },
                set(value){
                    this.$store.commit('rules/setItemsLocal', {
                        items: value
                    });
                }
            },
            curTopSection (){
                if(this.topSections[0]){
                    for (let i in this.topSections) {
                        if(this.topSections[i].id == this.activeTopSection){
                            return this.topSections[i];
                        }
                    }
                    return {};
                }
                else
                    return {};
            },
            isRemovedPage (){
                return this.$route.name == 'rules-removed';
            },
        },
        methods: {
            handleOffset(e, item){
                this.scrollTop = e.layerY;
                this.currentItem = item;
                let strongElem = false;
                if(e.target){
                    this.textElem = e.target
                    if(e.target.tagName != 'STRONG'){
                        this.stringNum = [...this.textElem.childNodes].indexOf(window.getSelection().anchorNode);
                    }else{
                        this.stringNum = 0;
                        strongElem = [...e.target.parentElement.childNodes].findIndex((i) => i.innerHTML === e.target.innerHTML);

                    }
                }

                this.offsetX = window.getSelection().getRangeAt(0).startOffset;
                if(e.altKey){
                    if((this.getRights(item) === 'W'  && !item.finally)  && !this.isRemovedPage || (this.user.access_rights.is_owner || this.getRights(item) === 'C') && !this.isRemovedPage){
                        this.$store.commit('rules/setUseShortcut', true);
                        this.$store.commit('rules/setLoadEditRule', true);
                        this.$store.commit('rules/setCursorPositionObj', {
                            scrollTop: this.scrollTop,
                            stringNum: this.stringNum,
                            offsetX: this.offsetX,
                            strongElem: strongElem
                        });
                        this.openAddRule(item);
                    }
                }
            },

            openRecover: function (item) {
              this.recoverItem = item;
              this.$store.commit('popups/open', {name: this.popups.recoverRule.name});
            },
			openAddRuleParent: function () {
				this.$emit('openAddRule');
            },
            openRemoveRule: function (item) {
                //this.$store.commit('popups/close', {name: this.popups.addRule.name});
                if(this.isRemovedPage){
                    this.$store.dispatch('rules/setEditItem',item).then(()=>{
                        this.$store.commit('popups/open', {name: this.popups.removeRuleForever.name});
                    });
                }
                else{
                    this.$store.dispatch('rules/setEditItem',item).then(()=>{
                        this.$store.commit('popups/open', {name: this.popups.removeRule.name});
                    });
                }
            },
            copyRule(e, item){
                let text = process.env.VUE_APP_PATH_FRONT + "/rule/?id=" + item.id;
                let elem = e.target.classList.contains('i') ? e.target.parentElement : e.target;
                if(e.target.classList.contains('i')){
                    e.target.parentElement.classList.add('copied');
                    setTimeout(function(){
                        e.target.parentElement.classList.remove('copied');
                    }, 500);
                }else{
                    e.target.classList.add('copied');
                    setTimeout(function(){
                        e.target.classList.remove('copied');
                    }, 500);
                }
                copyTextToClipboard(text);
            },
            dragSave: function (e) {
                if (this.drag) {
                    this.$store.dispatch('rules/setRulesSort', {isRemoved: this.$route.name == 'rules-removed'}).then((data) => {
                      if (+data.error === 403) {
                        this.$store.commit('popups/open', {name: this.popups.sectionForbiddenError.name});
                      }
                    });
                    this.drag = false;
                    setTimeout(()=>{
                        this.canToggle = true;
                    }, 400);
                }
            },
            dragStart: function (e) {
            },
            dragStatus: function (e) {
                this.drag = true;
                this.canToggle = false;
            },
            ruleColor(i) {
                let classesColor = {
                        0: '--blank',
                        1: '--blank',
                        2: '--draft',
                        3: '--rule',
                        4: '--rule',
                        5: '--archive',
                        6: '--blank',
                    },
                    selected = 0;

                if (typeof classesColor[i] !== 'undefined') {
                    selected = classesColor[i];
                }

                return selected;
            },
            ruleTypeName(i) {
                let name = '';
                if (typeof this.typesOptions[i] !== 'undefined') {
                    name = this.typesOptions[i]['name'];
                }

                return name;
            },
            goToRule(link){
                this.$store.commit('rules/setIsSearch', false);
                this.$router.push(link);
            },
            toggleRule(index, item, evt){
                let alt = evt ? evt.altKey : false;
                document.title = item.name;
                if(!this.isSearch && !alt && !this.drag && !this.isScreencasts){
                    document.querySelector('.rules').style.opacity = '0';
                    this.$store.commit('rules/setScrollTop', document.documentElement.scrollTop);
                    if(this.canToggle){
                        this.$store.dispatch('rules/getRuleText',{item: item, index: index, removed: this.isRemovedPage}).then(()=>{
                            this.$store.commit('rules/toggleRule', index);
                            this.$store.dispatch('popups/open', {name: this.popups.ruleDetail.name});
                            this.$store.commit('rules/setOpenedRule', index);
                            document.documentElement.scrollTop = 0;
                            if(item.updated){
                                this.$store.dispatch('rules/deleteMarks', {id:item.id});
                            }
                        });
                    }
                    this.highlightedId = false;
                }else if(!this.drag){
                    window.location.href = process.env.VUE_APP_PATH_FRONT + "/rule/?id=" + item.id;
                }
            },
            getRights(item) {
              let section = this.topSections.find(sect => sect.id === item.sectionTop),
                  rights = 'R';

              if (typeof(section) !== 'undefined') {
                rights = section.rights;
              }

              return rights;
            },
            fetchData () {
                return new Promise((resolve, reject) => {
                    this.$nextTick(()=> {
                        if(this.activeSection || this.isRemovedPage){
                            this.highlightedId = false;
                            let full = false;
                            if(this.$route.hash !== "") {
                                full = true;
                            }

                            let id = this.activeSection;
                            if(this.isRemovedPage){ id = 'removed';}

                            this.$store.dispatch('rules/getItems', {id: id, reload: true, full: full, ruleType: this.filterRuleType.value, topSect: this.activeTopSection}).then(()=>{
                                resolve();
                            });
                        } else {
                            resolve();
                        }
                    })
                });
            },
            handleScroll: function () {
                let scroll = window.scrollY;
                let viewport = window.innerHeight;
                let bodyHeight = document.body.clientHeight;
                if(bodyHeight-80 <= scroll + viewport){
                    this.$store.dispatch('rules/getItems', {
                        id: this.isRemovedPage ? 'removed' : this.activeSection,
                    })
                }
            },
            openEditAdminDisabled: function () {
              this.$store.dispatch('popups/open', {name: this.popups.editAdminDisabled.name});
            },
            toggleRoll(){
              this.$store.commit('rules/toggleRolled');
            },
            openAddRule: function (item) {
              this.toggleRoll();
              this.$emit('openeditrule')
              if (this.isSearch) {
                this.$store.commit('rules/setIsSearch', false);
                this.$store.commit('rules/setIsSearchPrev', true);
              } else {
                  this.$store.commit('rules/setPreviousSection', {topSection: this.activeTopSection, section: this.activeSection});
              }

              if(this.$route.path !== '/sid'+item.sectionTop+'/sub'+item.section+'/'){
                  if(item.sectionTop != item.section){
                      this.$router.push('/sid'+item.sectionTop+'/sub'+item.section+'/');
                  } else if(this.previousSection.top.id) {
                      this.$router.push('/sid'+this.activeTopSection+'/sub'+item.section+'/');
                  }
              }

              //очистка от <span class="query"></span>
              let tmpDiv = document.createElement("div");
              tmpDiv.innerHTML = item.name;
              item.name = tmpDiv.innerText;

              if(!item.isCheckEdit){
                    let timeout = setTimeout(()=>{
                        this.$store.commit('rules/setCheckEditLoader',{id:item,value: true});
                    },500)

                    this.$store.commit('rules/setLoadItems', true);
                    this.$store.dispatch('rules/checkEditItem',item).then((result)=>{
                        if(result.status){
                            this.$store.commit('rules/setLoadItems', false);
                            this.$store.commit('popups/open', {name: this.popups.editDisabled.name});
                        } else {
                            if(this.$route.name == 'rules-removed'){
                                this.$router.push('/sid'+item.sectionTop+'/sub'+item.section+'/');
                            }

                            this.$store.dispatch('rules/setEditItem',item).then(()=>{
                              this.$store.dispatch('popups/open', {name: this.popups.addRule.name});
                            })
                            document.documentElement.scrollTop = 0;

                        }
                        clearTimeout(timeout);
                        this.$store.commit('rules/setCheckEditLoader',{id:item,value: false});
                    },()=>{
                        this.$store.commit('rules/setCheckEditLoader',{id:item,value: false});
                    }).catch(()=>{
                        this.$store.commit('rules/setCheckEditLoader',{id:item,value: false});
                    })
                }

            },
            slide(payload){
                this.currentSlide = +payload.currentSlide == -1 ? this.files.length : +payload.currentSlide +1;
                if(this.files && +this.currentSlide > this.files.length){
                    this.currentSlide = 1;
                }
                this.currentSlidePrev = +payload.slideFrom
                this.pauseVideos();
            },
            pauseVideos() {
                [...document.getElementsByTagName('iframe')].forEach(i => i.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'));
            },
            openSearchField: function () {
                setTimeout(() => {
                    let searchFieldInput = document.getElementById('searchFieldInput');
                    this.$store.commit('rules/openSearchField', true);
                    searchFieldInput.focus();
                }, 100);
            },
            htmlText(text){
                return text.replace(/(?:\r\n|\r|\n)/g, '<br />');
            },
            removedSectionsBreadcrumbs(item) {
                let html = '';
                if (item.sections_before && item.sections_before.length) {
                    html += `${item.sectionTop === item.sections_before[0].id || item.sectionTopName === null ? '' : `<span>${item.sectionTopName}</span> / `}`;
                    html += item.sections_before.map(section => {
                        return `<span class="${section.removed ? 'line-through' : ''}">${section.name}</span>`;
                    }).join(' / ');
                }
                return html;
            },
        },
        watch: {
            '$route': 'fetchData',
            isLoadEditRule(val, oldVal){
                if(!this.isLoadEditRule && this.useShortcut){
                    this.setCursorPos(this.currentItem);
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
    }
</script>
<style scoped>
</style>
